// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Banner from '../../../../elements/Banner/Banner';
import { FormattedMessage } from 'react-intl';
import WishListBox from '../WishListBox/WishListBox';

import style from './WishListCatalog.scss';
import icons from '../../../../assets/styles/icons.scss';

import type { WishList as WishListType } from '../../../../entities';
import type { HTTPError } from '../../../../error';
import { resetState } from '../../duck';
import Loading from '../../../../elements/Loading/Loading';

type Props = {
  +fetchWishLists: () => void;
  +isFetchingWishLists?: boolean;
  +wishLists?: WishListType[];
  +fetchWishListsError?: HTTPError;
  +resetState: () => void;
};

export default class WishListCatalog extends Component<Props> {
  componentDidMount() {
    const { fetchWishLists, wishLists } = this.props;
    if (!wishLists) {
      fetchWishLists();
    }
  }

  componentWillUnmount() {
    const { resetState } = this.props;
    resetState();
  }

  render() {
    const { wishLists, isFetchingWishLists } = this.props;
    return (
      <Fragment>
        <Banner color="blue"
                titleElement={<FormattedMessage id="wishListCatalog.banner.title">{
                  txt => <h1><i className={icons.iconStarMedium}/> {txt}</h1>
                }</FormattedMessage>}/>
        <FormattedMessage id="wishListCatalog.banner.subtitle">{
          text => <h2 className={style.wishListCatalogSubtitle}>{text}</h2>
        }</FormattedMessage>

        <section className={style.wishListCatalogWrap}>
          {isFetchingWishLists && <Loading className={style.loading}
                                           color="lightBlue"/>}
          {!!wishLists && wishLists.map((wishList: WishListType, index: number) =>
            <WishListBox key={index}
                         wishList={wishList}
                         index={index}/>)}
        </section>
      </Fragment>
    );
  }
}

WishListCatalog.propTypes = {
  fetchWishLists: PropTypes.func.isRequired,
  isFetchingWishLists: PropTypes.bool,
  wishLists: PropTypes.array,
  fetchWishListsError: PropTypes.object,
  resetState: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/wish-list-catalog/components/WishListCatalog/WishListCatalog.jsx